export default function ServiceCTA() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Oswald, sans-serif' }}>
          Ready to Get Started?
        </h2>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          Contact us today for a free, no-obligation quote on any of our parking lot services.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="#quote"
            className="inline-flex items-center justify-center px-8 py-4 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all whitespace-nowrap cursor-pointer"
          >
            Get Your Free Quote
            <i className="ri-arrow-right-line ml-2 text-xl"></i>
          </a>
          <a
            href="tel:[ADD PHONE]"
            className="inline-flex items-center justify-center px-8 py-4 border-2 border-gray-900 text-gray-900 font-bold rounded-lg hover:bg-gray-900 hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2 text-xl"></i>
            Call Us Now
          </a>
        </div>
      </div>
    </section>
  );
}
